import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    viewBox: "0 0 28 24"
  }, props),
  /* @__PURE__ */ React.createElement("rect", { width: 28, height: 24, fill: "#fff", rx: 4 }),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#090E13",
      d: "M5.086 7.8h-.96L1.798 9.576v1.692l1.896-1.536V16.2h1.392V7.8Zm1.838 8.52a.907.907 0 0 0 .924-.912.9.9 0 0 0-.924-.912.907.907 0 0 0-.924.912c0 .504.408.912.924.912Zm1.597-.12h5.712v-1.368H10.79l1.656-1.656c1.044-.984 1.728-1.884 1.728-2.928 0-1.5-1.188-2.568-2.784-2.568-1.632 0-2.94 1.212-2.94 2.94l1.38.072c.012-1.032.6-1.644 1.548-1.644.78 0 1.356.516 1.356 1.236 0 .66-.42 1.152-1.284 2.004L8.521 15.18v1.02Zm8.762.12c1.644 0 2.952-1.248 2.952-2.832 0-1.68-1.188-2.796-2.748-2.796-.492 0-.996.132-1.308.36l.192-1.932h3.324V7.8H15.11l-.372 4.38 1.224.252c.288-.324.792-.504 1.32-.504.852 0 1.512.648 1.512 1.536 0 .828-.66 1.488-1.512 1.488-.804 0-1.5-.54-1.716-1.332l-1.284.408c.228 1.332 1.5 2.292 3 2.292Zm8.919-.12-2.148-3.036 2.004-2.832h-1.584l-1.224 1.716-1.212-1.716h-1.62l2.028 2.844-2.148 3.024h1.596l1.344-1.896 1.356 1.896h1.608Z"
    }
  )
);
var SvgSpeed125XFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var Speed125XFilled_default = SvgSpeed125XFilled;

export { Speed125XFilled_default as default };
